import { Tooltip } from 'antd';
import React from 'react';

interface ITooltipWithIconProps {
  children: React.ReactNode;
  title: string;
  onClick?: (e: any) => void;
  disable?: boolean;
  placement?: 'top' | 'left' | 'right' | 'bottom';
}
const TooltipWithIcon: React.FC<ITooltipWithIconProps> = ({ children, title, onClick, disable, placement = 'top' }) => {
  if (disable) {
    return null;
  }
  return (
    <Tooltip placement={placement} title={title} className="tooltip-with-icon">
      <div onClick={onClick}>{children}</div>
    </Tooltip>
  );
};

export default TooltipWithIcon;
